import React from 'react';
import { Link } from 'react-router-dom';
import './About.css';

const About = () => {
  return (
    <div className="about-page">
      <div className="container">
        <h1 className="about-title">About MasaiLink</h1>
        <p className="about-subtitle">Your Link to Masai Group Quality</p>
        
        <div className="about-content">
          {/* MasaiLink Overview */}
          <div className="about-section highlight-section">
            <h2>Welcome to MasaiLink</h2>
            <p className="lead-text">
              We are proud <strong>authorized distributors</strong> for the entire Masai Group of Companies, 
              bringing you Kenya's most trusted industrial products through a single, reliable source.
            </p>
            <p>
              MasaiLink was founded to bridge the gap between quality manufacturers and Kenya's growing 
              construction and industrial sectors. We combine technical knowledge with industry experience 
              to ensure you get the right products for your project - whether it's a borehole installation, 
              building construction, or industrial wiring.
            </p>
          </div>

          {/* The Masai Group Companies */}
          <div className="about-section">
            <h2>The Masai Group of Companies</h2>
            
            <div className="company-grid">
              {/* Masai Cables */}
              <div className="company-card">
                <div className="company-icon">⚡</div>
                <h3>Masai Cables Limited</h3>
                <p className="company-tagline">Building Stronger Connections</p>
                <p>
                  Kenya's premier cable manufacturer, producing superior quality cables for power distribution, 
                  construction, and industrial applications. With manufacturing capacity of 160 MT of copper 
                  and 200 MT of aluminium, we deliver internationally certified quality cables for every application.
                </p>
                <div className="company-specs">
                  <span>✓ ISO 9001:2015 Certified</span>
                  <span>✓ KEBS Approved</span>
                  <span>✓ 99.9% Pure Copper</span>
                </div>
                <Link to="/products" className="company-link">Browse Cables →</Link>
              </div>

              {/* Masai Store / Versil Pumps */}
              <div className="company-card">
                <div className="company-icon">💧</div>
                <h3>Masai Store Ltd</h3>
                <p className="company-tagline">Connecting Water With You</p>
                <p>
                  Sole importers and distributors of Versil brand submersible and mono block pumps in Kenya. 
                  We provide complete water solutions - from borehole drilling to pump installation, with 
                  Italian technology and stainless steel construction.
                </p>
                <div className="company-specs">
                  <span>✓ Italian Technology</span>
                  <span>✓ Stainless Steel</span>
                  <span>✓ 1 Year Warranty</span>
                </div>
                <Link to="/pump-products" className="company-link">Browse Pumps →</Link>
              </div>

              {/* Masai Rolling Mills */}
              <div className="company-card">
                <div className="company-icon">🔩</div>
                <h3>Masai Rolling Mills Ltd</h3>
                <p className="company-tagline">Quality Steel for a Stronger Kenya</p>
                <p>
                  Leading manufacturer of TMT bars, steel billets, and structural steel sections. 
                  We recycle scrap steel for sustainable construction, producing earthquake-resistant 
                  Fe-500 and Fe-550 grade TMT bars for infrastructure projects.
                </p>
                <div className="company-specs">
                  <span>✓ Fe-500/Fe-550 Grade</span>
                  <span>✓ 50,000+ Tons/Year</span>
                  <span>✓ KEBS Approved</span>
                </div>
                <Link to="/steel-products" className="company-link">Browse Steel →</Link>
              </div>
            </div>
          </div>

          {/* Our Mission */}
          <div className="about-section mission-section">
            <h2>Our Mission</h2>
            <p>
              To be the most trusted link between quality manufacturers and consumers in Kenya, 
              providing genuine products, expert technical advice, and exceptional service that 
              builds lasting relationships and stronger connections.
            </p>
          </div>

          {/* Manufacturing Excellence */}
          <div className="about-section">
            <h2>Manufacturing Excellence</h2>
            <div className="stats-grid">
              <div className="stat-card">
                <h3>160 MT</h3>
                <p>Copper Cable Capacity</p>
              </div>
              <div className="stat-card">
                <h3>200 MT</h3>
                <p>Aluminium Cable Capacity</p>
              </div>
              <div className="stat-card">
                <h3>50+</h3>
                <p>Pump Models</p>
              </div>
              <div className="stat-card">
                <h3>50,000+</h3>
                <p>Tons Steel/Year</p>
              </div>
            </div>
          </div>

          {/* Quality Assurance */}
          <div className="about-section">
            <h2>Quality Assurance</h2>
            <div className="quality-grid">
              <div className="quality-item">
                <span className="quality-icon">🏅</span>
                <h4>ISO 9001:2015 Certified</h4>
                <p>International quality management system</p>
              </div>
              <div className="quality-item">
                <span className="quality-icon">🔬</span>
                <h4>In-house Testing Lab</h4>
                <p>Regular testing and quality control</p>
              </div>
              <div className="quality-item">
                <span className="quality-icon">✓</span>
                <h4>KEBS Approved</h4>
                <p>All products meet Kenya standards</p>
              </div>
              <div className="quality-item">
                <span className="quality-icon">🔴</span>
                <h4>99.9% Pure Copper</h4>
                <p>EC grade for maximum conductivity</p>
              </div>
              <div className="quality-item">
                <span className="quality-icon">🔥</span>
                <h4>FRLS Technology</h4>
                <p>Fire Retardant Low Smoke PVC</p>
              </div>
              <div className="quality-item">
                <span className="quality-icon">🏭</span>
                <h4>In-house Manufacturing</h4>
                <p>Complete control from wire drawing to packing</p>
              </div>
            </div>
          </div>

          {/* Our Facilities */}
          <div className="about-section">
            <h2>Our Facilities</h2>
            <p>
              All processes from wire drawing from rods, annealing, insulating to packing are performed 
              under one roof at our Kitengela facility, ensuring complete quality control and efficiency 
              in production. Our strategic location along Mombasa Road enables fast and efficient deliveries 
              across Nairobi and surrounding counties.
            </p>
          </div>

          {/* Why Choose MasaiLink */}
          <div className="about-section why-section">
            <h2>Why Choose MasaiLink?</h2>
            <div className="features-list">
              <div className="feature">
                <span className="feature-bullet">✓</span>
                <div>
                  <h4>Direct from Manufacturer</h4>
                  <p>We source directly from Masai factories - no middlemen, better prices</p>
                </div>
              </div>
              <div className="feature">
                <span className="feature-bullet">✓</span>
                <div>
                  <h4>100% Genuine Products</h4>
                  <p>Authentic Masai Cables, Versil Pumps, and MRM Steel with certifications</p>
                </div>
              </div>
              <div className="feature">
                <span className="feature-bullet">✓</span>
                <div>
                  <h4>Technical Expertise</h4>
                  <p>Get the right product for your specific application</p>
                </div>
              </div>
              <div className="feature">
                <span className="feature-bullet">✓</span>
                <div>
                  <h4>Reliable Delivery</h4>
                  <p>Fast delivery to Nairobi, Kajiado, and surrounding areas</p>
                </div>
              </div>
              <div className="feature">
                <span className="feature-bullet">✓</span>
                <div>
                  <h4>Bulk Pricing</h4>
                  <p>Competitive rates for contractors and large projects</p>
                </div>
              </div>
              <div className="feature">
                <span className="feature-bullet">✓</span>
                <div>
                  <h4>After-Sales Support</h4>
                  <p>Technical support and service for all products</p>
                </div>
              </div>
            </div>
          </div>

          {/* Contact Information */}
          <div className="about-section contact-section">
            <h2>Contact Information</h2>
            <div className="contact-grid">
              <div className="contact-card">
                <h3>Masai Cables Ltd</h3>
                <p>📞 +254 745 910 871</p>
                <p>✉️ sales.mcl@masaigroup.co.ke</p>
                <p>📍 Kitengela, Off Mombasa Road</p>
              </div>
              <div className="contact-card">
                <h3>Masai Store Ltd (Pumps)</h3>
                <p>📞 0700 241467</p>
                <p>✉️ masaistoreltd@gmail.com</p>
                <p>📍 Kajiado, Kenya</p>
              </div>
              <div className="contact-card">
                <h3>Masai Rolling Mills</h3>
                <p>📞 0738 200500</p>
                <p>✉️ info.mrm@masaigroup.co.ke</p>
                <p>📍 Kitengela Township</p>
              </div>
            </div>
            <div className="main-office">
              <p><strong>Head Office:</strong> P.O.Box 344 - 00242, Kitengela, Kenya</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;